// 반려 재신청 화면 상태 — 서버가 준 폼 초기값 → 회사 정보 칸 값 → 보낼 입력(값·함수는 컴포넌트 밖에 둔다).

import type { OrgCreateInput } from "@buildpy/core/modules/onboarding/rules";
import { reapplyOrg, type OrgCreateForm, type OrgCreateResult } from "@/api/actions/onboarding";
import { refreshActiveViews } from "@/lib/query";
import { companyErrorOf, EMPTY_WIZARD, orgCreateFormOf, type WizardValues } from "./onboarding-wizard-state";

export const REAPPLY_FAILED_MESSAGE = "다시 신청하지 못했습니다. 잠시 후 다시 시도하세요.";
export const REAPPLY_LOAD_FAILED_MESSAGE = "회사 정보를 불러오지 못했습니다. 잠시 후 다시 시도하세요.";
export const REAPPLY_TITLE = "회사 정보를 고쳐 다시 신청";

// 서버 폼 초기값 → 칸 값 · 규모(선택) 값도 그대로 이어 보낸다.
export const reapplyValuesOf = (form: OrgCreateInput): WizardValues => ({
  ...EMPTY_WIZARD,
  name: form.name,
  slug: form.slug,
  ceo: form.ceo,
  tel: form.tel,
  address: form.address ?? "",
  bizNo: form.bizNo ?? "",
  licenseNo: form.licenseNo ?? "",
  staffSize: form.staffSize,
  workTypes: [...form.workTypes],
  monthlySites: form.monthlySites,
  source: form.source,
});

// 보낼 입력 — 주소(slug)·약관은 서버가 정한다 · 담당자 이름·연락처는 지금 값 그대로.
export const reapplyInputOf = (v: WizardValues, owner: Pick<OrgCreateInput, "ownerName" | "ownerPhone">): Omit<OrgCreateForm, "agree" | "slug"> => {
  const { agree: _agree, slug: _slug, ...rest } = orgCreateFormOf(v);
  return { ...rest, ownerName: owner.ownerName, ownerPhone: owner.ownerPhone ?? undefined };
};

// 보내기 전 검사 — 입점 검사 한 벌(core).
export const reapplyErrorOf = companyErrorOf;

// 재신청 보내기 — 성공하면 셸을 다시 읽어(D5) 레이아웃이 승인 대기 화면으로 바꾼다(다시 마운트돼도 옛 반려 셸이 안 남는다).
export const sendReapply = async (input: Omit<OrgCreateForm, "agree" | "slug">): Promise<OrgCreateResult> => {
  const result = await reapplyOrg(input);
  if (result.ok) await refreshActiveViews();
  return result;
};
